/*
  SH Updated: October 2026 - SE #1660, tag-aware free delivery bar.
  The theme's freeShippingBar (theme.js) sets the bar from cart.total_price only, on load and on
  every cart change. This file watches for those writes and, when the cart holds a FREE PENNY PUZZLE
  product (Denmark only; rule in snippets/sh-cart-free-tag.liquid), shows her message and a full
  green line. When the product leaves the cart, the theme's own state is put back.
  theme.js is never edited (SH-THEME-OVERRIDES landmine); this file only reads and sets the bar's DOM.
*/
(function () {
  if (window.shFreeShippingTag) return;
  window.shFreeShippingTag = true;

  var BAR = "[data-free-shipping-bar]";
  var MSG = ".free-shipping-bar__message";
  var PROGRESS = ".free-shipping-bar__bar"; // the theme sets --progress-width here, and the inner line inherits it
  var tagFree = null; // last known state from the server; null until first read
  var pending = null;

  function bars() {
    return Array.prototype.slice.call(document.querySelectorAll(BAR));
  }

  function snapshot(bar) {
    // Keep the theme's latest write, so it can be put back when the tag leaves the cart.
    var msg = bar.querySelector(MSG);
    var progress = bar.querySelector(PROGRESS);
    if (!msg || msg.textContent === bar.dataset.shTagMessage) return false;
    var next = {
      html: msg.innerHTML,
      over: bar.dataset.isOverThreshold,
      width: progress ? progress.style.getPropertyValue("--progress-width") : ""
    };
    var prev = bar._shTheme;
    bar._shTheme = next;
    return !prev || prev.html !== next.html || prev.over !== next.over || prev.width !== next.width;
  }

  function apply(bar, free) {
    var msg = bar.querySelector(MSG);
    var progress = bar.querySelector(PROGRESS);
    if (!msg) return;
    if (free) {
      if (bar.dataset.shTagActive !== "true") bar.dataset.shTagActive = "true";
      if (bar.dataset.isOverThreshold !== "true") bar.dataset.isOverThreshold = "true";
      if (msg.textContent !== bar.dataset.shTagMessage) msg.textContent = bar.dataset.shTagMessage;
      if (progress && progress.style.getPropertyValue("--progress-width") !== "100%") {
        progress.style.setProperty("--progress-width", "100%");
      }
    } else if (bar.dataset.shTagActive === "true") {
      bar.dataset.shTagActive = "false";
      var t = bar._shTheme;
      if (t) {
        bar.dataset.isOverThreshold = t.over;
        msg.innerHTML = t.html;
        if (progress) progress.style.setProperty("--progress-width", t.width);
      }
    }
  }

  function applyAll() {
    if (tagFree === null) return;
    bars().forEach(function (bar) {
      apply(bar, tagFree);
    });
  }

  function readState() {
    var bar = document.querySelector(BAR);
    if (!bar || !bar.dataset.shStateUrl) return;
    if (pending) pending.abort();
    var controller = window.AbortController ? new AbortController() : null;
    pending = controller;
    fetch(bar.dataset.shStateUrl, { credentials: "same-origin", signal: controller ? controller.signal : undefined })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var m = html.match(/data-sh-free-tag-state="(true|false)"/);
        if (!m) return;
        tagFree = m[1] === "true";
        applyAll();
      })
      .catch(function () {});
  }

  var scheduled = false;
  function onChange() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      var themeWrote = false;
      bars().forEach(function (bar) {
        if (snapshot(bar)) themeWrote = true;
        // A freshly rendered bar carries the server's answer in its markup.
        if (tagFree === null && bar.dataset.shTagFree) tagFree = bar.dataset.shTagFree === "true";
      });
      applyAll(); // last known state first, so a tagged cart does not flash the countdown
      if (themeWrote) readState(); // the cart may have changed: confirm with the server
    });
  }

  // The theme announces add, change and remove only on its own internal bus, so watch the cart
  // requests themselves: any finished /cart/add, /cart/change, /cart/update or /cart/clear re-reads the state.
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  function isCartWrite(url) {
    try { return CART_WRITE.test(new URL(url, window.location.href).pathname + "?"); } catch (e) { return false; }
  }
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      var result = nativeFetch.apply(this, arguments);
      if (isCartWrite(url)) result.then(function () { readState(); }, function () {});
      return result;
    };
  }
  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartWrite(url)) this.addEventListener("loadend", function () { readState(); });
    return nativeOpen.apply(this, arguments);
  };

  new MutationObserver(onChange).observe(document.body, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ["data-is-over-threshold", "data-is-loaded"]
  });
  onChange();
})();
